var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "12px",
    viewBox: "0 0 21 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C68827A4-D0C7-404B-8BE2-7E0C3DDB83B2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---4---colour-,-chasis,-date---2",
    transform: "translate(-957.000000, -482.000000)",
    fill: "#605F5E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(100.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(343.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15102-Copy",
    transform: "translate(0.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.498947,51.3778693 C529.787189,46.0861441 532.43131,43.4402814 532.43131,43.4402814 C533.018442,42.8532462 533.967811,42.8532462 534.54869,43.4402814 C535.129569,44.0273367 535.129569,44.9765829 534.54869,45.5636382 C534.54869,45.5636382 525.560753,54.5566432 525.560753,54.5566432 C524.992378,55.1249447 524.080461,55.1374472 523.493349,54.6003618 C523.493349,54.6003618 514.442952,45.5698693 514.442952,45.5698693 C514.149386,45.2763417 514.005729,44.8891457 514.005729,44.508201 C514.005729,44.1272563 514.149386,43.7400402 514.442952,43.4465327 C515.030063,42.8594975 515.979452,42.8594975 516.560331,43.4465327 C516.560331,43.4465327 519.206537,46.0903116 524.498947,51.3778693 Z",
    id: "Icon-ionic-ios-arrow-down-Copy-2",
    transform: "translate(524.493821, 49.000000) rotate(360.000000) translate(-524.493821, -49.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e6d5935e2f4654f648a7b8f81b58ed66.svg";
export { ForwardRef as ReactComponent };